import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link as RouterLink } from "react-router-dom"

import { ReactFC } from 'types'

import { User } from './profile.types'
import Link from '@material-ui/core/Link'
import { memberProfileUrl } from './profile.places'


export const MemberProfileLink: ReactFC<{ user: User }> = ({ user, children }) => {
  const to = memberProfileUrl(user)
  return (
    <Link component={RouterLink} to={to} underline="always" >
      {children}
    </Link>
  )
}

export default MemberProfileLink
